import React from "react";
import { Box, Grid } from "@material-ui/core";

import CostActionsDataGrid from "./CostActionsDataGrid";

const CostActions: React.FC = () => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box display="flex" flexDirection="column" >
                    <Box flexGrow={1} width='100%' height={'60vh'} >
                        <CostActionsDataGrid />
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default CostActions;
